import normalize from "json-api-normalizer";

const uuidv4 = require("uuid/v4");

export const createUserDomain = ({
  name,
  screenShotTime,
  formattedUser,
  subscription,
  campaignLocked,
  campaignLockedDuration,
  centerLocation
}) => ({
  _jsonapi: {
    data: {
      type: "domains",
      attributes: {
        name,
        screenshot_time: screenShotTime,
        domain_users_attributes: [...formattedUser],
        subscription,
        campaign_locked: campaignLocked,
        campaign_locked_duration: campaignLockedDuration,
        map_central_location: centerLocation
      }
    }
  }
});

export const addUserDomain = (id, { roles, users }) => ({
  _jsonapi: {
    data: {
      type: "domains",
      attributes: {
        id,
        domain_users_attributes: [
          { roles: roles.map(item => item.value), user_id: users.value }
        ]
      }
    }
  }
});
export const removeUserFromDomain = (id, userId) => ({
  _jsonapi: {
    data: {
      type: "domains",
      attributes: {
        id,
        domain_users_attributes: [{ user_id: userId }]
      }
    }
  }
});

export const addDeviceToDomain = (id, { deviceToAdd }) => ({
  _jsonapi: {
    data: {
      type: "domains",
      attributes: {
        id
      },
      relationships: {
        devices: {
          data: [...deviceToAdd]
        }
      }
    }
  }
});

export const removeDeviceFromDomain = (id, deviceID) => ({
  _jsonapi: {
    data: {
      type: "domains",
      attributes: {
        id
      },
      relationships: {
        devices: {
          data: [{ type: "devices", id: deviceID }]
        }
      }
    }
  }
});

export const Resources = {
  addDomain: {
    url: "/domains",
    asyncActions: {
      init: "addDomain_INIT",
      success: "addDomain_SUCCESS",
      error: "addDomain_ERROR"
    }
  },
  getDomains: {
    url: `/domains`,
    asyncActions: {
      init: "getDomains_INIT",
      success: "getDomains_SUCCESS",
      error: "getDomains_ERROR"
    }
  },
  updateDomain: {
    asyncActions: {
      init: "updateDomain_INIT",
      success: "updateDomain_SUCCESS",
      error: "updatDomain_ERROR",
      successMsg: "Domain updated Successfully ✓"
    }
  },
  deleteDomain: {
    url: `/domains/id`,
    asyncActions: {
      init: "deleteDomain_INIT",
      success: "deleteDomain_SUCCESS",
      error: "deleteDomain_ERROR"
    }
  },
  switchDomain: {
    url: `domains/id`,
    asyncActions: {
      init: "switchDomain_INIT",
      success: "switchDomain_SUCCESS",
      error: "switchDomain_ERROR"
    }
  },
  getDomainsDetails: (domainID = undefined) => ({
    url: `/domains/${domainID}`,
    asyncActions: {
      init: "getDomainsDetails_INIT",
      success: "getDomainsDetails_SUCCESS",
      error: "getDomainsDetails_ERROR"
    }
  }),
  // setDomainDefaultCampaign: (campaignID = undefined) => ({
  //   url: `/campaigns/${campaignID}/set_default_campaign`,
  //   asyncActions: {
  //     init: "setDefaultCampaign_INIT",
  //     success: "setDefaultCampaign_SUCCESS",
  //     error: "setDefaultCampaign_ERROR"
  //   }
  // }),
  updateUserRole: {
    asyncActions: {
      init: "updateUserRole_INIT",
      success: "updateUserRole_SUCCESS",
      error: "updateUserRole_ERROR"
    }
  },
  reloadHeader: {
    syncActions: {
      reload: "RELOAD_header"
    }
  },
  getDomainUsers: {
    url: `/domains/`,
    asyncActions: {
      init: "getDomainUsers_INIT",
      success: "getDomainUsers_SUCCESS",
      error: "getDomainUsers_ERROR"
    }
  },
  getDomainDevices: {
    url: `/domains/`,
    asyncActions: {
      init: "getDomainDevices_INIT",
      success: "getDomainDevices_SUCCESS",
      error: "getDomainDevices_ERROR"
    }
  },
  autoCompletePlace: text => ({
    url: `/campaigns/autocomplete_places?search_params=${text}`,
    asyncActions: {
      init: "autoCompletePlace_INIT",
      success: "autoCompletePlace_SUCCESS",
      error: "autoCompletePlace_ERROR"
    }
  })
};

const initialState = {
  list: { devices: [], users: [], domains: [] },
  links: undefined,
  status: undefined,
  statusText: undefined,
  meta: undefined,
  deleted: undefined,
  edited: undefined,
  hasList: undefined,
  loading: undefined,
  hasError: undefined
};

const initialStateFormDomainList = {
  list: undefined,
  links: undefined,
  status: undefined,
  statusText: undefined,
  meta: undefined,
  deleted: undefined,
  edited: undefined,
  hasList: undefined,
  loading: undefined,
  hasError: undefined
};
export function domainList(
  state = { ...initialStateFormDomainList, newDomains: [] },
  action
) {
  const { init, success, error } = Resources.getDomains.asyncActions;

  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data: { data, links, meta },
        status,
        statusText
      } = action.payload;
      return {
        list: data,
        newDomains: state.list,
        links,
        status,
        statusText,
        meta,
        deleted: [],
        edited: [],
        hasList: true,
        loading: false,
        hasError: false
      };
    }
    case "infinite_domain-scroll": {
      return {
        ...action.payload
      };
    }

    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    default: {
      return state;
    }
  }
}

export function reloadHeaderDispatcher() {
  const { reload } = Resources.reloadHeader.syncActions;
  return dispatch => {
    dispatch({ type: reload, payload: null });
  };
}

export function reloadHeader(state = {}, { type, payload }) {
  const { reload } = Resources.reloadHeader.syncActions;
  switch (type) {
    case reload:
      return { reload: uuidv4() };

    default:
      return state;
  }
}

export function domainDetails(state = { ...initialState }, action) {
  const { init, success, error } = Resources.getDomainsDetails().asyncActions;

  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data: { data, links, meta },
        status,
        statusText
      } = action.payload;
      return {
        list: normalize({ ...action.payload.data }),
        links,
        status,
        statusText,
        meta,
        deleted: [],
        edited: [],
        hasList: true,
        loading: false,
        hasError: false
      };
    }

    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    default: {
      return state;
    }
  }
}

export function domainUsers(state = {}, action = {}) {
  const { init, success, error } = Resources.getDomainUsers.asyncActions;

  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data: { data, links, meta },
        status,
        statusText
      } = action.payload;
      return {
        list: data,
        links,
        status,
        statusText,
        meta,
        deleted: [],
        edited: [],
        hasList: true,
        loading: false,
        hasError: false
      };
    }

    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    default: {
      return state;
    }
  }
}

export function domainDevices(state = {}, action = {}) {
  const { init, success, error } = Resources.getDomainDevices.asyncActions;

  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data: { data, links, meta },
        status,
        statusText
      } = action.payload;
      return {
        list: data,
        links,
        status,
        statusText,
        meta,
        deleted: [],
        edited: [],
        hasList: true,
        loading: false,
        hasError: false
      };
    }

    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    default: {
      return state;
    }
  }
}

export function updateDomainInfiniteScroll() {
  return (dispatch, getState) => {
    const { list, newDomains } = getState().domainList;
    const state = getState().domainList;
    state.list = [...newDomains, ...list];
    dispatch({
      type: "infinite_domain-scroll",
      payload: state
    });
  };
}
